<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Modulo de pago de servicios</h2>
    <MainServicesDGII />
  </div>
</template>

<script>
import MainServicesDGII from "@/components/ServicesDGII/MainServicesDGII.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ServicesDGII",
  components: {
    MainServicesDGII,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
